export const DELETE_COMMENT_PERMISSION = "delete_comment";
export const SWITCH_USER_PERMISSION = "switch_user";
